export default "__VITE_ASSET__BDnP59Kq__"